export default __webpack_public_path__ + "static/media/leads-tab-icon.1069ac96.svg";